import { RegistrationFormInfoDto } from '../generated';
import { FormInfo } from '../model/FormInfo';
import { parseClinic } from './clinic.parser';

export const parseFormInfo = (data: RegistrationFormInfoDto): FormInfo => {
  return {
    clinics: data.clinics.map(parseClinic)
  };
};
